import { EventBus } from 'Phaser/EventBus';
import Cursor from 'Phaser/GameObjects/Cursor';

export class TestExercise extends Phaser.Scene {
  progressBar?: Phaser.GameObjects.Rectangle;
  t: number = 0.0;
  cursor: Cursor | null = null;

  constructor() {
    super('TestExercise');
  }

  stop() {
    this.scene.stop();
  }

  create(): void {
    EventBus.emit('current-scene-ready', this);
  }

  init(_config: Record<string, unknown>) {}
}
